import { ReactComponent as PortfolioIcon } from '../../../assets/icons/sidebarMenuIcons/portfolio.svg';
import { ReactComponent as PortfolioActiveIcon } from '../../../assets/icons/sidebarMenuIcons/portfolio-active.svg';
import { ReactComponent as SetupIcon } from '../../../assets/icons/sidebarMenuIcons/setup.svg';
import { ReactComponent as SetupActiveIcon } from '../../../assets/icons/sidebarMenuIcons/setup-active.svg';
import { ReactComponent as IssuersIcon } from '../../../assets/icons/sidebarMenuIcons/issuers.svg';
import { ReactComponent as IssuersActiveIcon } from '../../../assets/icons/sidebarMenuIcons/issuers-active.svg';
import { ROUTES } from '../../../constants/routes';
import { TMenuItem, USER_ROLE } from '../../../types';
import { useIssuersPendingEvaluation } from '../../../hooks/useIssuersPendingEvaluation';
import { useMemo } from 'react';

export const useManagerComplianceMenuItems = () => {
  const { companiesData } = useIssuersPendingEvaluation();

  const managerComplianceMenuItems: TMenuItem[] = useMemo(
    () => [
      {
        title: 'Issuers',
        icon: <IssuersIcon />,
        iconActive: <IssuersActiveIcon />,
        id: ROUTES.ISSUERS,
        showForRoles: [USER_ROLE.MANAGER, USER_ROLE.COMPLIANCE],
        subItems: [
          {
            title: 'Evaluated Issuers',
            route: ROUTES.ISSUERS,
            id: ROUTES.ISSUERS,
            showForRoles: [USER_ROLE.MANAGER, USER_ROLE.COMPLIANCE],
          },
          {
            title: 'Pending Evaluation',
            route: ROUTES.PENDING_EVALUATION,
            id: ROUTES.PENDING_EVALUATION,
            showForRoles: [USER_ROLE.MANAGER, USER_ROLE.COMPLIANCE],
            badgeNum: companiesData?.length || 0,
          },
        ],
      },
      {
        title: 'Control Companies',
        icon: <PortfolioIcon />,
        iconActive: <PortfolioActiveIcon />,
        route: `${ROUTES.PORTFOLIO}/${ROUTES.REQUESTS}`,
        id: ROUTES.PORTFOLIO,
        showForRoles: [USER_ROLE.COMPLIANCE, USER_ROLE.MANAGER],
      },
      {
        title: 'Setup',
        icon: <SetupIcon />,
        iconActive: <SetupActiveIcon />,
        id: 'setup',
        showForRoles: [USER_ROLE.MANAGER, USER_ROLE.COMPLIANCE],
        hasTopBorder: true,
        subItems: [
          {
            title: 'Companies',
            route: ROUTES.COMPANIES,
            id: ROUTES.COMPANIES,
            showForRoles: [USER_ROLE.MANAGER, USER_ROLE.COMPLIANCE],
          },
          {
            title: 'Exclusions',
            route: ROUTES.INVESTOR_EXCLUSIONS,
            id: ROUTES.INVESTOR_EXCLUSIONS,
            showForRoles: [USER_ROLE.MANAGER, USER_ROLE.COMPLIANCE],
          },
        ],
      },
    ],
    [companiesData?.length]
  );

  return managerComplianceMenuItems;
};
